import { BfaConstants } from '@ddt-web/domain';

import { NumberUtil } from './number.util';

export class PercentFormatter {
	constructor(private decimal: number = BfaConstants.DEFAULT_DECIMAL_PLACES) { }
	public format(value: any, showPlusOrMinus?: boolean): string {
		const formattedValue = typeof value === 'number' ? NumberUtil.formatNumber(value * 100, this.decimal) + '%' : value;
		return showPlusOrMinus && value > 0 ? '+' + formattedValue : formattedValue;
	}
}
